import { render, staticRenderFns } from "./AutoActivitiesForm.vue?vue&type=template&id=377286e9&lang=pug&"
import script from "./AutoActivitiesForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./AutoActivitiesForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports